/**
 * @ngdoc config
 * @name routeProviderConfig
 * @description
 * Sets the routes for the TOS section:
 * - The default one (`/tos`).
 *
 * @param {Service} $routeProvider The interface for the Angular router.
 * @memberof tos
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/tos', {
    template: '<tos></tos>',
  });
};

export default routeProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/tos/configs/routeProvider.config.js